import React, { useEffect } from 'react';
import { FileUploaderPreview } from '../FileUploaderPreview';
import { TicketWhatsApp } from '../TicketWhatsApp';
import { EvidenciaImg, CustomGarage, Solicitud, Appointment } from '../../types/ot.types';

interface Step2Props {
    imagenesIngreso: EvidenciaImg[];
    setImagenesIngreso: React.Dispatch<React.SetStateAction<EvidenciaImg[]>>;
    stepTwoFormAppointment: string;
    setStepTwoFormAppointment: (val: string) => void;
    selectedGarage?: CustomGarage;
    detalleSolicitud?: Solicitud;
    appointments: Appointment[];
    stepOneFormAppointment: string;
    isCompleted?: boolean;
    minFechaRecepcion?: string;
}

export const Step2Ingreso: React.FC<Step2Props> = (props) => {
    useEffect(() => {
        console.log("props", props);
    }, [])

    return (
        <div className="row g-3 text-start">
            <div id="ot-step2-fecha-ingreso" className="col-sm-6 col-lg-6">
                <div className="form-group">
                    <label className="fw-bold mb-1">
                        Fecha de ingreso real
                        {props.isCompleted && (
                            <span className="badge bg-success ms-2 fw-normal">
                                <i className="fas fa-check-circle"></i> Ingreso Registrado
                            </span>
                        )}
                    </label>
                    <input
                        type="datetime-local"
                        className={`form-control shadow-sm ${props.isCompleted ? 'text-muted border-success' : ''}`}
                        value={(props.stepTwoFormAppointment || "")}
                        onChange={(e) => props.setStepTwoFormAppointment(e.target.value)}
                        disabled={props.isCompleted}
                        min={props.minFechaRecepcion}
                    />
                </div>
            </div>

            <div id="ot-step2-evidencia-ingreso" className="col-sm-6 col-lg-6">
                <FileUploaderPreview
                    label="Evidencia de ingreso e inventario (Fotos/Videos/PDF)"
                    archivos={props.imagenesIngreso}
                    setArchivos={props.setImagenesIngreso}
                    disabled={props.isCompleted}
                    multiple={true}
                    accept="image/*,video/mp4,application/pdf"
                />
            </div>

            {props.selectedGarage && props.detalleSolicitud && props.stepOneFormAppointment && (
                <div id="ot-step2-voucher-section" className="col-12 border-top pt-3 mt-4">
                    <h6 className="fw-bold mb-3">
                        <i className="fab fa-whatsapp text-success me-2"></i>
                        Pase de Ingreso para el Cliente
                    </h6>
                    <TicketWhatsApp
                        taller={props.selectedGarage}
                        solicitud={props.detalleSolicitud}
                        fechaCita={props.stepOneFormAppointment}
                    />
                </div>
            )}
        </div>
    );
};
